import(/* webpackMode: "eager" */ "/vercel/path0/apps/quark/public/assets/logos/quark/dark-h.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/@mui+material@5.16.7_@emotion+react@11.13.3_@types+react@18.3.12_react@18.3.1__@emotion+style_5fmx4zgukdrr7c4hrz6h7clcfi/node_modules/@mui/material/AppBar/index.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/@mui+material@5.16.7_@emotion+react@11.13.3_@types+react@18.3.12_react@18.3.1__@emotion+style_5fmx4zgukdrr7c4hrz6h7clcfi/node_modules/@mui/material/Box/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/.pnpm/@mui+material@5.16.7_@emotion+react@11.13.3_@types+react@18.3.12_react@18.3.1__@emotion+style_5fmx4zgukdrr7c4hrz6h7clcfi/node_modules/@mui/material/Toolbar/Toolbar.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.1.11_@babel+core@7.28.5_@opentelemetry+api@1.9.0_babel-plugin-macros@3.1.0_react-dom@_vmxaonv2jhhnn5k527lpsigije/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/vercel/path0/node_modules/.pnpm/react-hot-toast@2.4.1_csstype@3.2.3_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/react-hot-toast/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["MeProvider"] */ "/vercel/path0/packages/features/auth/src/providers/me/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["I18nClientProvider"] */ "/vercel/path0/packages/shared/i18n/src/provider/i18n-client.provider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/shared/router/src/components/button-link.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/shared/router/src/components/link.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/shared/router/src/components/locale-switcher.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/shared/router/src/hooks/router-provider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/shared/router/src/hooks/use-decode-pathname-with-query-params.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/shared/router/src/hooks/use-decode-pathname.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/shared/router/src/hooks/use-router.ts");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/shared/tracking/src/datadog/rum-listener.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/shared/tracking/src/nps/components/nps-form-stepper/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/shared/tracking/src/nps/components/nps-gauge/nps-gauge.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/shared/tracking/src/nps/components/nps-survey/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/shared/tracking/src/nps/components/nps-textarea/nps-textarea.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/shared/tracking/src/nps/components/relationship-banner/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/shared/tracking/src/nps/components/transactional-modal/index.tsx");
